import { Icon } from './semantic-ui-antd-adapter'
import { Popover } from 'antd'
import { Redirect, Switch, useHistory } from 'react-router'
import { Route, NavLink } from 'react-router-dom'
import { colors } from '../theme'
import {
  useAuthDispatch,
  useAuthSelector,
  authStore,
  selectTokenValid,
  selectSessionChecked,
  selectShouldChangePassword,
  hasPerm,
  useAuthState,
} from '../stores/authStore'
import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import { AlteraSenha } from '../pages/AlteraSenha/AlteraSenha'
import { Avatar } from './Avatar'
import { Chat } from '../pages/Chat/Chat'
import { ChatContactList } from '../pages/ChatContactList/ChatContactList'
import { ChatMensagem } from '../pages/ChatMensagem/ChatMensagem'
import { Cursos } from '../pages/Cursos/Cursos'
import { EditorConteudo } from '../pages/EditorConteudo/EditorConteudo'
import { Flex, styles, DisplayFlex } from './Styles'
import { Foruns } from '../pages/Foruns/Foruns'
import { Historico } from '../pages/Historico/Historico'
// Remove IStateRedux import - using new store pattern
import { Modulos } from '../pages/Modulos/Modulos'
import { ModulosEditar } from '../pages/Modulos/ModulosEditar'
import { Perfil } from '../pages/Perfil/Perfil'
import { Progresso } from '../pages/Progresso/Progresso'
import { Questoes } from '../pages/Questoes/Questoes'
import { Alunos, AlunosEditar, AlunosMatricular } from '../pages/Alunos'
import { Cupons } from '../pages/Cupons/Cupons'
import { getUsuarioLogado } from '../stores/authStore'
import { filesUrl } from '..'
import useAxios from 'axios-hooks'
import { Certificados } from '../pages/Certificados/Certificados'
import { copyToClipboard } from '../util/copyToClipboard'
import { Isencao } from '../pages/Isencao/Isencao'
import { DefinirSenha } from '../pages/DefinirSenha/DefinirSenha'
import { DetranLogs } from '../pages/DetranLogs/DetranLogs'
import { DetranActions } from '../pages/DetranActions/DetranActions'
import { Turmas } from '../pages/Turmas/Turmas'
import { NotasFiscais } from '../pages/NotasFiscais/NotasFiscais'
import { Bi } from '../pages/Bi/Bi'
import { PortalArtigos } from '../pages/PortalArtigos/PortalArtigos'
import { ParceirosList } from '../pages/Parceiros/ParceirosList'
import { ParceiroDetail } from '../pages/Parceiros/ParceiroDetail'
import { Show } from './Util'
import { ouvirSolicitacoesDeTurmaAtualizadas } from '../lib/turmasEvents'
import { PERMS } from '../permissions/perms'
import { Inicio } from '../pages/Inicio/Inicio'
import { StoreHome, TMenuOptions } from '../stores/homeStore'

interface PainelRoute {
  path: string
  component: React.ComponentType<any>
  perm?: string
}

const routes: PainelRoute[] = [
  { path: '/inicio', component: Inicio },
  { path: '/altera-senha', component: AlteraSenha },
  { path: '/perfil', component: Perfil },
  {
    path: '/cursos/:cursoId/modulos/novo',
    component: ModulosEditar,
    perm: PERMS.CURSO_GERENCIAR,
  },
  {
    path: '/cursos/:cursoId/modulos/:moduloId/editar',
    component: ModulosEditar,
    perm: PERMS.CURSO_GERENCIAR,
  },
  {
    path: '/cursos/:cursoId/usuarios/:usuarioId/acompanhamento',
    component: Progresso,
    perm: PERMS.ALUNO_VER,
  },
  {
    path: '/cursos/:cursoId/alunos/editar/:usuarioId?',
    component: AlunosEditar,
    perm: PERMS.ALUNO_VER,
  },
  {
    path: '/cursos/:cursoId/alunos/',
    component: AlunosMatricular,
    perm: PERMS.ALUNO_VER,
  },
  { path: '/cursos', component: Cursos, perm: PERMS.CURSO_GERENCIAR },
  { path: '/certificados', component: Certificados, perm: PERMS.CERTIFICADO_GERENCIAR },
  { path: '/conteudo/:moduloId', component: EditorConteudo, perm: PERMS.CURSO_GERENCIAR },
  // { path: '/modulos', component: Modulos },
  { path: '/foruns', component: Foruns, perm: PERMS.ALUNO_VER },
  { path: '/historico/:usuarioId', component: Historico, perm: PERMS.ALUNO_VER },
  { path: '/chat/alunos', component: ChatContactList, perm: PERMS.ALUNO_VER },
  { path: '/chat/:chatId', component: ChatMensagem, perm: PERMS.ALUNO_VER },
  { path: '/chat', component: Chat, perm: PERMS.ALUNO_VER },
  { path: '/cupons', component: Cupons, perm: PERMS.CUPOM_GERENCIAR },
  { path: '/alunos', component: Alunos, perm: PERMS.ALUNO_VER },
  { path: '/turmas', component: Turmas, perm: PERMS.TURMA_GERENCIAR },
  { path: '/notas-fiscais', component: NotasFiscais, perm: PERMS.NOTA_FISCAL_GERENCIAR },
  { path: '/portal-artigos', component: PortalArtigos, perm: PERMS.PORTAL_GERENCIAR },
  { path: '/isencoes', component: Isencao, perm: PERMS.MATRICULA_ALTERAR_VALOR },
  { path: '/detran-logs', component: DetranLogs, perm: PERMS.DETRAN_OPERAR },
  { path: '/detran-actions', component: DetranActions, perm: PERMS.DETRAN_OPERAR },
  { path: '/bi', component: Bi, perm: PERMS.BI_VER },
  { path: '/parceiros/:id', component: ParceiroDetail, perm: PERMS.PARCEIRO_GERENCIAR },
  { path: '/parceiros', component: ParceirosList, perm: PERMS.PARCEIRO_GERENCIAR },
]

export function Home() {
  const isTokenValid = useAuthSelector(selectTokenValid)
  const sessionChecked = useAuthSelector(selectSessionChecked)
  // const shouldChangePassword = useAuthSelector(selectShouldChangePassword)
  if (!sessionChecked) return null
  if (!isTokenValid) return <Redirect to="/login" />
  // if (shouldChangePassword) return <DefinirSenha />

  return (
    <StoreHome.Provider>
      <Container>
        <Nav>
          {/* <img src={require('../assets/New_Driver_Negativo.png')} /> */}
          <ContainerOptionsNav />
          <Flex />
          <SenhaMaster />
          {/* <i className="bell outline icon" style={{ fontSize: '25px' }}></i> */}
          <UsuarioLogado />
        </Nav>
        <ContainerMenuContent>
          {/* <Menu /> */}
          <Content>
            <Switch>
              {routes.map((route) => (
                <PermittedRoute key={route.path} {...route} />
              ))}
            </Switch>
          </Content>
        </ContainerMenuContent>
        {/* <DevTools /> */}
      </Container>
    </StoreHome.Provider>
  )
}

function PermittedRoute({ path, component, perm }: PainelRoute) {
  const authState = useAuthState()
  if (perm && !hasPerm(authState, perm)) {
    return <Route path={path} render={() => <Redirect to="/inicio" />} />
  }
  return <Route path={path} component={component} />
}

const ContainerOptionsNav = () => {
  const { Layout, Option } = ContainerOptionsNav
  const { menuOptionSelected, certificadosPendentesTotal, solicitacoesTurmaTotal } =
    StoreHome.useState()
  const dispatch = StoreHome.useDispatch()
  const history = useHistory()
  const authState = useAuthState()

  const podeVerCertificados = hasPerm(authState, PERMS.CERTIFICADO_GERENCIAR)
  const podeVerTurmas = hasPerm(authState, PERMS.TURMA_GERENCIAR)

  useEffect(() => {
    if (!podeVerCertificados) return
    dispatch(StoreHome.thunks.getCertificadosPendentesTotal())
    const interval = setInterval(
      () => dispatch(StoreHome.thunks.getCertificadosPendentesTotal()),
      60 * 1000
    )
    return () => clearInterval(interval)
  }, [dispatch, podeVerCertificados])

  useEffect(() => {
    if (!podeVerTurmas) return
    const recarregar = () => dispatch(StoreHome.thunks.getSolicitacoesTurmaTotal())
    recarregar()
    return ouvirSolicitacoesDeTurmaAtualizadas(recarregar)
  }, [dispatch, podeVerTurmas])

  const handleSelectOptionMenu = (option: TMenuOptions) => {
    const route = option === 'certificados' ? '/certificados/pendentes' : `/${option.toLowerCase()}`
    history.push(route)
    dispatch(StoreHome.actions.changeMenuOptionSelected(option))
  }

  return (
    <Layout>
      <Show condition={hasPerm(authState, PERMS.ALUNO_VER)}>
        <Option
          onClick={() => handleSelectOptionMenu('Alunos')}
          active={menuOptionSelected === 'Alunos'}
        >
          Alunos
        </Option>
      </Show>
      <Show condition={hasPerm(authState, PERMS.CURSO_GERENCIAR)}>
        <Option
          onClick={() => handleSelectOptionMenu('Cursos')}
          active={menuOptionSelected === 'Cursos'}
        >
          Cursos
        </Option>
      </Show>
      <Show condition={hasPerm(authState, PERMS.TURMA_GERENCIAR)}>
        <Option
          onClick={() => handleSelectOptionMenu('Turmas')}
          active={menuOptionSelected === 'Turmas'}
        >
          Turmas
          {solicitacoesTurmaTotal > 0 && <PendingBadge>{solicitacoesTurmaTotal}</PendingBadge>}
        </Option>
      </Show>
      <Show condition={hasPerm(authState, PERMS.CUPOM_GERENCIAR)}>
        <Option
          onClick={() => handleSelectOptionMenu('Cupons')}
          active={menuOptionSelected === 'Cupons'}
        >
          Cupons
        </Option>
      </Show>
      {/* <Option
        onClick={() => handleSelectOptionMenu('Isencoes')}
        active={menuOptionSelected === 'Isencoes'}
      >
        Isenções
      </Option> */}
      <Show condition={hasPerm(authState, PERMS.DETRAN_OPERAR)}>
        <Option
          onClick={() => handleSelectOptionMenu('detran-logs')}
          active={menuOptionSelected === 'detran-logs'}
        >
          Logs DETRAN
        </Option>
        <Option
          onClick={() => handleSelectOptionMenu('detran-actions')}
          active={menuOptionSelected === 'detran-actions'}
        >
          Ações DETRAN
        </Option>
      </Show>
      <Show condition={hasPerm(authState, PERMS.NOTA_FISCAL_GERENCIAR)}>
        <Option
          onClick={() => handleSelectOptionMenu('notas-fiscais')}
          active={menuOptionSelected === 'notas-fiscais'}
        >
          Notas Fiscais
        </Option>
      </Show>
      <Show condition={hasPerm(authState, PERMS.CERTIFICADO_GERENCIAR)}>
        <Option
          onClick={() => handleSelectOptionMenu('certificados')}
          active={menuOptionSelected === 'certificados'}
        >
          Certificados Pendentes
          {certificadosPendentesTotal > 0 && (
            <PendingBadge>{certificadosPendentesTotal}</PendingBadge>
          )}
        </Option>
      </Show>
      <Show condition={hasPerm(authState, PERMS.PORTAL_GERENCIAR)}>
        <Option
          onClick={() => handleSelectOptionMenu('portal-artigos')}
          active={menuOptionSelected === 'portal-artigos'}
        >
          Portal
        </Option>
      </Show>
      <Show condition={hasPerm(authState, PERMS.PARCEIRO_GERENCIAR)}>
        <Option
          onClick={() => handleSelectOptionMenu('parceiros')}
          active={menuOptionSelected === 'parceiros'}
        >
          Parceiros
        </Option>
      </Show>
      <Show condition={hasPerm(authState, PERMS.BI_VER)}>
        <Option onClick={() => handleSelectOptionMenu('bi')} active={menuOptionSelected === 'bi'}>
          BI
        </Option>
      </Show>
    </Layout>
  )
}

ContainerOptionsNav.Layout = styled.div`
  display: flex;
`
ContainerOptionsNav.Option = styled.div<{ active: boolean }>(
  ({ active }) => `
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  gap: 8px;
  color: ${active ? '#373737;' : '#FFFFFF;'}
  cursor: pointer;
  font-weight: 700;
  font-size: 17px;
`
)

const PendingBadge = styled.span`
  position: absolute;
  top: 10px;
  right: -10px;
  min-width: 22px;
  height: 22px;
  border-radius: 999px;
  background: #ff4d4f;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  line-height: 1;
  animation: badge-bounce 3s ease-in-out infinite;
  pointer-events: none;

  @keyframes badge-bounce {
    0%,
    85%,
    100% {
      transform: translateY(0);
    }
    92% {
      transform: translateY(-3px);
    }
  }
`

const SenhaMaster = () => {
  const authState = useAuthState()

  if (!hasPerm(authState, PERMS.SENHA_MASTER_VER)) return null
  return <SenhaMasterValor />
}

const SenhaMasterValor = () => {
  const { Layout } = SenhaMaster
  const [{ data }, req] = useAxios('/usuarios/senha-master')

  useEffect(() => {
    const interval = setInterval(() => req(), 60 * 1000)
    return () => clearInterval(interval)
  })

  function copy() {
    copyToClipboard(data)
  }

  return (
    <Layout>
      <span>
        Senha Master: <strong>{data}</strong>
      </span>
      <Icon name="redo" onClick={req} />
      <Icon name="copy outline" onClick={copy} />
    </Layout>
  )
}
SenhaMaster.Layout = styled.div`
  align-self: center;
  display: flex;
  gap: 8px;
  i {
    cursor: pointer;
  }
`

const Menu = () => {
  return (
    <MenuStyled>
      <MenuItem to="/inicio">Início</MenuItem>
      <MenuItem to="/cursos">Cursos</MenuItem>
      <MenuItem to="/foruns">Fóruns</MenuItem>
      <MenuItem to="/chat">Chat</MenuItem>
      <MenuItemPlaceholder />
    </MenuStyled>
  )
}

const UsuarioLogado = () => {
  const dispatch = useAuthDispatch()
  const usuario = useAuthSelector(getUsuarioLogado)
  const goToPerfil = () => null
  const changeSenha = () => null

  const handleLogout = () => {
    dispatch(authStore.thunks.doLogout())
  }

  const popoverContent = (
    <div>
      <PopupItemElement onClick={goToPerfil}>Perfil</PopupItemElement>
      <PopupItemElement onClick={changeSenha}>Alterar Senha</PopupItemElement>
      <PopupItemElement onClick={handleLogout}>Sair</PopupItemElement>
    </div>
  )

  return (
    <PopupElement>
      <Popover
        content={popoverContent}
        trigger="hover"
        placement="bottomRight"
        overlayStyle={{ minWidth: 150 }}
      >
        <DisplayFlex marginBetween={6} center={true}>
          <div style={{ border: '2px solid white', borderRadius: '50%' }}>
            <Avatar usuario={usuario} circular={true} tamanho={39} />
          </div>
          {/* <div> {usuario.nome} </div> */}
        </DisplayFlex>
      </Popover>
    </PopupElement>
  )
}

const MenuItem = React.memo(({ children, to }: any) => {
  return (
    <MenuItemStyled activeClassName="active" to={to}>
      {children}
    </MenuItemStyled>
  )
})

const Container = styled('div')`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-image: ${styles.bg};
  background-size: cover;
`

const Nav = styled('div')`
  height: 76px;
  background-color: var(--primary-color);
  width: 100%;
  margin-bottom: 1px;
  color: white;
  display: flex;
  img {
    height: 45px;
    width: 123px;
    margin: 13px 42px;
  }
`

const ContainerMenuContent = styled('div')`
  display: flex;
  overflow: auto;
  height: calc(100vh - 76px);
`

const MenuStyled = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
`
const MenuItemStyled = styled(NavLink)`
  color: #fff;
  &:hover {
    background-color: ${styles.color.bgHover};
    color: #fff;
  }
  &.active {
    border-right: 6px solid ${styles.color.blue};
  }
  font-size: 16px;
  background-color: ${styles.color.bg};
  line-height: 63px;
  margin-bottom: 1px;
  transition: background 0.3s;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 16px;
  cursor: pointer;
`

const MenuItemPlaceholder = styled('div')`
  flex: 1;
  background-color: ${styles.color.bg};
`

const Content = styled('div')`
  flex: 1;
  min-width: 0;
  display: flex;
  & > div {
    flex: 1;
    min-width: 0;
  }
`

const PopupItemElement = styled('div')`
  padding: 4px 12px;
  cursor: pointer;
  text-align: right;
  &:after {
    display: block;
    content: '';
    border-bottom: solid 1px ${styles.color.orange};
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 250ms ease-in-out;
  }
  &:hover:after {
    transform: scaleX(1);
  }
`
const PopupElement = styled('div')`
  display: flex;
  align-items: center;
  padding: 0 12px;
  cursor: pointer;
`

const AvatarStyled = styled('img')`
  border-radius: 50%;
  width: 32px;
`
